<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="organizations ? organizations : []"
      :search="search"
      :loading="fetchAllLoading"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn icon small color="primary" class="ma-2" @click="$emit('refresh')">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="$emit('createNew')">
            <v-icon left>add</v-icon>Create
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" color="primary" @click="$emit('editOrga', item)" dark>mdi-pencil</v-icon>
        <v-icon color="error" @click="$emit('deleteOrga', item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Name",
          align: "start",
          filterable: true,
          value: "name",
          width: "80%"
        },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ]
    };
  },
  computed: {
    ...mapState({
      organizations: state => state.organizations.all,
      fetchAllLoading: state => state.organizations.fetchAll.pending,
      fetchAllError: state => state.organizations.fetchAll.error
    })
  }
};
</script>